export default __webpack_public_path__ + "static/media/Games-3.924afec6.png";